import React from 'react'
import { Updater, async, fromJSX, Widget } from 'widgets-for-react'
import { LinkBlock, LinkBlockItem, LinkBlockLayout } from '../linkBlockLayout'
import { CourseOverviewBlockState } from './courseOverviewState'
import { navigate } from 'widgets-for-react'

export type CourseOverviewBlock = Omit<LinkBlock, 'items'> & {
  coursesState: CourseOverviewBlockState
}

export const courseOverviewWidget = (
  block: CourseOverviewBlock
): Widget<Updater<CourseOverviewBlockState>> => (
  // Add redirect from Course group page -> Course page if only 1 Course is a child of the Group
  async<LinkBlockItem[]>(block.coursesState, courses => {
    if (courses.length == 1) navigate(courses[0].url)
    return fromJSX(() => (
      <LinkBlockLayout
        {...block}
        items={courses}
        SVGIcon={{
          width: '20px',
          height: '22px'
        }}
        isCourseList={true}
      />
    ))
  })
)